import { render, staticRenderFns } from "./Passbilder.vue?vue&type=template&id=2f8af132&scoped=true&"
import script from "./Passbilder.vue?vue&type=script&lang=js&"
export * from "./Passbilder.vue?vue&type=script&lang=js&"
import style0 from "./Passbilder.vue?vue&type=style&index=0&id=2f8af132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8af132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VImg,VRow})
